var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"position":"relative"},style:({height: _vm.height,width: _vm.width})},[_c('div',{ref:"grafica",staticStyle:{"height":"100%","width":"100%","position":"relative"}})])}
var staticRenderFns = []

export { render, staticRenderFns }